class MHeader extends HTMLElement {
  constructor() {
    super(),
      (this.selectors = {
        headers: ["header"],
        logos: [".m-logo"],
        topbar: ".m-topbar",
        hamburgerButtons: ".m-hamburger-box",

        headerWrapper: ".m-header__wrapper",
        topbarClose: ".m-topbar__close",
        searchInput: ".m-search-form__input", // Search input field
        searchResults: ".m-search-popup", // Search results container
      }),
      (this.domNodes = queryDomNodes(this.selectors, this)),
      (this.innerWidth = window.innerWidth),
      (this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop),
      (this.headerHeight = this.domNodes.headerWrapper.offsetHeight),
      (this.stickyEnabled = "true" === this.dataset.sticky || !1),
      (this.classes = {
        scrollUp: "scroll-up",
        scrollDown: "scroll-down",
        stuck: "stuck",
      }),
      this.init();
  }

  init() {
    (this.transparentHeader =
      this.domNodes &&
      this.domNodes.headers[0] &&
      "true" === this.domNodes.headers[0].dataset.transparent),
      this.initAddon(),
      this.handleSticky(),
      this.handleSearch(), // Ensure search handling works
      document.addEventListener("matchMobile", () => this.handleSticky()),
      document.addEventListener("unmatchMobile", () => this.handleSticky()),
      (this.siteNav = new SiteNav(this)),
      (window.__sfHeader = this),
      window.addEventListener("resize", () => {
        this.innerWidth = window.innerWidth;
      }),
      this.transparentHeader && this.innerWidth > 1280
        ? this.domNodes.headerWrapper &&
          this.domNodes.headerWrapper.classList.add("transparent-on-top")
        : this.domNodes.headerWrapper &&
          this.domNodes.headerWrapper.classList.remove("transparent-on-top");
  }

  handleSearch() {
    if (!this.domNodes.searchInput || !this.domNodes.searchResults) return;

    this.domNodes.searchInput.addEventListener("input", (event) => {
      const query = event.target.value.trim();
      if (query.length > 1) {
        this.domNodes.searchResults.style.display = "block";
      } else {
        this.domNodes.searchResults.style.display = "none";
      }
    });

    // Allow typing inside and prevent accidental hiding
    this.domNodes.searchResults.addEventListener("click", (event) => {
      event.stopPropagation(); // Prevent hiding when clicking inside
    });

    // Hide results if user clicks outside the search area
    document.addEventListener("click", (event) => {
      if (
        !this.domNodes.searchResults.contains(event.target) &&
        !this.domNodes.searchInput.contains(event.target)
      ) {
        this.domNodes.searchResults.style.display = "none";
      }
    });
  }
}
customElements.define("m-header", MHeader);
